function sortByTitleOrFilename(a, b) {
  a = (a.title || a.filename || '').toLowerCase()
  b = (b.title || b.filename || '').toLowerCase()
  return a.localeCompare(b)
}

export default function sortAttachments(attachments) {
  return attachments.slice().sort(sortByTitleOrFilename)
}
